<template>
    <div>

        <div @click="toggleLightbox(0)">
            <slot></slot>
        </div>

        <div class="flex flex-wrap mt-1 items-center">
            <div v-for="(image, i) in images" class="bg-grey-3 mr-1" :key="i">
                <img @click="toggleLightbox(i)" class="thumb" :src="image.thumb" alt="Thumbnail">
            </div>
        </div>

        <VueLightBox ref="lightbox" v-if="show" :images="images" @onOpened="lightboxOpened"></VueLightBox>

    </div>
</template>

<script>
    import Vue from 'vue';
    import VueLightBox from 'vue-image-lightbox';
    import VueLazyLoad from 'vue-lazyload';

    Vue.use(VueLazyLoad);

    export default {

        name: 'LightBox',

        props: ['images'],

        components: {
            VueLightBox,
        },

        data() {
            return {
                show: false,
            }
        },

        methods: {

            toggleLightbox(i) {
                this.show = !this.show;

                if (i !== 'undefined') {
                    this.$nextTick(() => {
                        this.$refs.lightbox.showImage(i);
                    });
                }
            },

            lightboxOpened(state) {
                this.show = state;
            },

        },

    }
</script>

<style scoped>
    .thumb {
        width: 50px;
        height: auto;
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/LightBox.vue